module.exports = __webpack_public_path__ + "static/img/5.279683e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/zh/5.png
// module id = /LfY
// module chunks = 0